module.exports = __webpack_public_path__ + "static/media/sy.6fbab619.svg";